/* globals angular, bzGlobal */
angular
  .module('bzConstantsModule')
  .constant('applicationConstants', bzGlobal.applicationConstants)
